module.exports = __webpack_public_path__ + "img/active-qiye.4a5f6166.png";